import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import {
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_ERROR,
  FORGOT_PASSWORD_SUCCESS,
  RESET,
  SET_ERROR,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_ERROR,
  UPDATE_PASSWORD_SUCCESS,
} from './resetPasswordConstants'

const initialState = {
  success: false,
  error: '',
  loading: false,
  emailSentSuccess: false,
  tokenExpired: false,
  emailToVerify: '',
  defaultServerErrorMessage: '',
}

export default function resetPasswordReducer(state = initialState, action = {}) {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case FORGOT_PASSWORD:
      return {
        ...state,
        emailSentSuccess: false,
        loading: true,
      }
    case UPDATE_PASSWORD:
      return {
        ...state,
        error: '',
        success: false,
        loading: true,
        defaultServerErrorMessage: '',
      }
    case UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
      }
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        emailSentSuccess: true,
        loading: false,
      }
    case SET_ERROR:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        error: action.payload,
      }
    case UPDATE_PASSWORD_ERROR: {
      let message = ''
      let defaultServerErrorMessage = ''
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
        message =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.UserFriendlyErrorCode ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
          : ''
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        defaultServerErrorMessage = action.payload.UserFriendlyErrorCode ? action.payload : ''
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        switch (action.payload.ErrorCode) {
          case 'TokenNotValid':
            return {
              ...state,
              tokenExpired: true,
              loading: false,
            }
          case 'PasswordNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'password')
            break
          case 'DuplicatePassword':
            message = getUserFriendlyErrorMessage(errorCodes.NEW_PASSWORD_MUST_BE_DIFFERENT)
            break
          case 'InternalServerError':
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            break
          default:
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            defaultServerErrorMessage = action.payload
            break
        }
      }
      return {
        ...state,
        error: message,
        loading: false,
        defaultServerErrorMessage,
      }
    }
    case FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        loading: false,
      }
    case RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
